var map = {
	"./gattav.webp": [
		687,
		687
	],
	"./icons/fiverr-logo.webp": [
		85
	],
	"./icons/github-mark.svg": [
		286,
		286
	],
	"./icons/x-logo.webp": [
		583
	],
	"./name_logo.svg": [
		137,
		137
	],
	"./tandoori.webp": [
		750,
		750
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 680;
module.exports = webpackAsyncContext;